export default function likes({ context }) {

    const devUrl = 'https://staging18.staging.gb.ru/api/v2/'
    const prodUrl = 'https://gb.ru/api/v2/'

    const baseUrl = context.$config.isProd ? prodUrl : devUrl

    return {
        async setLike(likableType, likableId) {
            try {
                const { data } = await context.$axios.post(`${baseUrl}${likableType}/${likableId}/like`)

                return data
            } catch (e) {
                console.error(e)
            }
        },

        async unlike(likableType, likableId) {
            try {
                const { data } = await context.$axios.post(`${baseUrl}${likableType}/${likableId}/unlike`)

                return data
            } catch (e) {
                console.error(e)
            }
        }
    }
}
